import formlist from './formlist';
export default formlist;



// WEBPACK FOOTER //
// ./src/components/formlist/index.js